<template>
  <b-sidebar
    v-if="isSidebarOpen"
    v-model="isSidebarOpen"
    id="sidebar-right"
    right
    backdrop
    shadow
    width="109em"
    backdrop-variant="dark"
    ref="editItem"
    no-close-on-backdrop
    @change="closeSidePanelCallback()"
  >
    <template #title>
      <div>
        <strong id="sidebar-right___title__">{{ label }}</strong>
        <b-button
          @click="exportTable('documentsTable', 'documents')"
          size="sm"
          class="ml-3 mb-1 mr-2"
        >
          Экспорт
          <b-icon
            icon="cloud-download"
            aria-hidden="true"
            v-if="!isExportData"
          ></b-icon>
          <i class="fas fa-spinner fa-spin" v-else></i>
        </b-button>
        <b-button @click="isMakeGraphPanel=!isMakeGraphPanel" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
          График
          <b-icon icon="bar-chart-line" aria-hidden="true" v-if="!isMakeGraphPanel"></b-icon>
          <b-icon icon="bar-chart-line-fill" aria-hidden="true" v-if="isMakeGraphPanel"></b-icon>
      </b-button>
      </div>
    </template>
    <div class="d-block">
      <template v-if="isMakeGraphPanel">
        <EasyGraphGenerator
            :items="items"
            :fields="fields"
            :allowedKeys="[
              'company.name',
              'company.source.name',
              'type.name',
              'creator.name',
              'date_of_document',
              'created_at'
            ]"
        ></EasyGraphGenerator>
      </template>
      
      <div class="position-relative">
        <b-table
          id="documentsTable"
          striped
          hover
          :sticky-header="computedWindowHeight"
          :items="items"
          :fields="fields"
          :busy="isTableBusy"
        >
          <template #cell()="data">
            <template v-if="data.field.loading">
              <template v-if="!data.value"
                ><i class="fas fa-spinner fa-spin ml-1"></i
              ></template>
              <template v-else>{{ data.value }}</template>
            </template>
            <template v-else>
              {{ data.value || "—" }}
            </template>
          </template>

          <template #cell(name)="data">
            <a download :href="hfs + data.item.path">{{ data.value }}</a>
          </template>

          <template #cell(company.name)="data">
            <span
                class="sidebar-link"
                @click="openCompanySidebar(data.item.company_id)"
            >
                {{ data.value }}
            </span>
          </template>          

          <template #cell(date_of_document)="{value}">
            {{ value | formattedDate }}
          </template>
          <template #cell(created_at)="{value}">
            {{ value | formattedDate }}
          </template>

          <template #table-busy>
            <div class="text-center text-success my-5">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </b-sidebar>
</template>
<script>
import { HOST_FOR_STORAGE, API_GET_DOCUMENTS_BY_IDS } from "@/constants";
import { excelExportHelpers } from "@/mixins";
import { openCompanySidebar } from '@/mixins/openCompanySidebar';
import EasyGraphGenerator from '@/components/charts/EasyGraphGenerator.vue';

export default {
  props: {
    openDocumentsList: { type: Boolean, required: true },
    documentsList: { type: Array, required: true },
    label: {
      type: String,
      default: "Список поставок/компаний",
      required: false,
    },
  },
  components: {
    EasyGraphGenerator
  },
  mixins: [excelExportHelpers, openCompanySidebar],
  data() {
    return {
      isTableBusy: false,
      computedWindowHeight: "",
      hfs: HOST_FOR_STORAGE,
      fields: [
        {
          key: "id",
          label: "ID",
          stickyColumn: true,
          sortable: true,
          sortDirection: "desc",
          visible: true,
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          key: "company.name",
          label: "Клиент",
          stickyColumn: true,
          sortable: true,
          sortDirection: "desc",
          visible: true,
        },
        {
          key: "company.source.name",
          label: "Источник клиента",
          stickyColumn: true,
          sortable: true,
          sortDirection: "desc",
          visible: true,
        },
        {
          key: "name",
          label: "Имя документа",
          stickyColumn: true,
          sortable: true,
          sortDirection: "desc",
          visible: true,
        },
        {
          key: "type.name",
          label: "Тип документа",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
          visible: true,
        },
        {
          key: "creator.name",
          label: "Создал",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
          visible: true,
        },
        {
          key: "date_of_document",
          label: "Дата составления документа",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
          visible: true,
        },
        {
          key: "created_at",
          label: "Дата загрузки",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
          visible: true,
        },
        {
          key: "order_id",
          label: "Заказ",
          sortable: true,
          sortDirection: "desc",
          visible: true,
        },
      ],
      items: [],
      isMakeGraphPanel: false
    };
  },
  watch: {
    documentsList: {
      handler(ids) {
        this.getDataHandler(ids);
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener("resize", this.handlerHeightWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.handlerHeightWindow);
  },
  mounted() {
    this.handlerHeightWindow();
  },
  methods: {
    handlerHeightWindow() {
      let deleteHeight = 115;
      this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`;
    },
    getDataHandler: async function (ids) {
      this.isTableBusy = true;
      this.isSidebarOpen = true;

      let finalIdsList = [];

      if (ids[0].order_id) {
        finalIdsList = ids.map((id) => {
          return id.order_id;
        });
      } else {
        finalIdsList = ids;
      }

      await api
        .call("post", API_GET_DOCUMENTS_BY_IDS, { document_ids: finalIdsList })
        .then((response) => {
          this.isTableBusy = false;
          this.items = response.data;
        });
    },
    closeSidePanelCallback() {
      this.closeDocumentsList();
      this.isSidebarOpen = false;
    },
    closeDocumentsList() {
      this.$emit("closeDocumentsList");
    },
    companyNameTdOutput(item, value) {
      if (item.short_order && item.short_order == 1) {
        return item.temp_name;
      }
      return value;
    },
  },
};
</script>
